import React from 'react'
import { useDispatch } from 'react-redux'

import { useSettingsPopupState } from '../hooks'
import { CustomFormPopup } from '../CustomFormPopup'
import { ModalDescriptorForType } from '../../../store/modals'
import { modalsActions } from '../../../store/modals/modalsSlice'
import { RADIO_WIDGET, RANGE_WIDGET, HIDDEN_WIDGET } from '../../../features/schema'

type Props = {
  modalDescriptor: ModalDescriptorForType<'knowledge_base_path_settings'>
}

const schema = {
  type: 'object',
  properties: {
    status: {
      type: 'string',
      title: 'Status',
      default: '',
      oneOf: [
        {
          title: 'Inherit',
          const: ''
        },
        {
          title: 'Used',
          const: 'used'
        },
        {
          title: 'Ignored',
          const: 'ignored'
        }
      ]
    },
    priority: { type: 'number', title: 'Priority', minimum: -10, maximum: 10 },
    splitter: {
      type: 'object',
      title: 'Splitter',
      properties: {
        maxChunkLength: { type: 'number', title: 'Max chunk length' },
        chunkOverlap: { type: 'string', title: 'Chunk overlap' }
      }
    },
    tags: {
      type: 'array',
      title: 'Tags',
      items: {
        type: 'string',
        title: 'Tag'
      }
    }
  },
  required: []
}

const uiSchema = {
  ignored: RADIO_WIDGET,
  priority: RANGE_WIDGET,
  splitter: { chunkOverlap: HIDDEN_WIDGET }
}

export const KnowledgeBasePathSettingsPopup: React.FC<Props> = ({ modalDescriptor }) => {
  const { path, settings, updatePathSettings } = modalDescriptor
  const initialFormData = settings || {
    status: '',
    splitter: {}
  }

  const dispatch = useDispatch()

  const { formData, onFormDataChange } = useSettingsPopupState(
    () => initialFormData,
    [modalDescriptor]
  ) as any

  const close = () => dispatch(modalsActions.closeModal())

  return (
    <CustomFormPopup
      title={`"${path}" path settings`}
      formData={formData}
      onChange={onFormDataChange}
      labels={{ buttons: { submit: 'Save' } }}
      onSubmit={formData => {
        updatePathSettings(path, formData)
        close()
      }}
      schema={schema}
      uiSchema={uiSchema}
    />
  )
}
